/**
 * Saves a file the server sent (a Blob) under `filename`. The object URL is
 * revoked a tick later: some browsers cancel a download whose URL is revoked
 * before it starts.
 */
export function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 0);
}

/**
 * The filename in a Content-Disposition header, or null. Null too when the
 * browser can't read the header: local dev calls the API on another port,
 * and CORS doesn't expose it.
 */
export function filenameFromDisposition(header) {
    const match = /filename="([^"]+)"/.exec(header || '');
    return match ? match[1] : null;
}
